type EntityState<Entity> = {
  byId: { [key: string]: Entity };
  allIds: string[];
}

export function createEntityState<Entity>(): EntityState<Entity> {
  return {
    byId: {},
    allIds: [],
  };
}

export type BaseEntity = {
  id: number;
}

export function setEntity<T extends BaseEntity>(state: EntityState<T>, entity: T): EntityState<T> {
  const newState = { ...state };

  if (!entity.id) {
    console.error('Entity needs to have an ID!');
    return newState
  }

  if (!state.allIds.includes(String(entity.id))) {
    newState.allIds = [
      ...state.allIds,
      String(entity.id)
    ];
  }

  newState.byId = {
    ...state.byId,
    [entity.id]: entity,
  };

  return newState;
}

export function setEntities<T extends BaseEntity>(state: EntityState<T>, entity: T[]): EntityState<T> {
  return entity.reduce(setEntity, state);
}

export function removeEntity<T extends BaseEntity>(state: EntityState<T>, id: string): EntityState<T> {
  const indexToRemove = state.allIds.findIndex((entityId): boolean => {
  return entityId === id
});

if (indexToRemove === -1) {
  return state;
}

const {[id]: omit, ...byId} = state.byId; // eslint-disable-line @typescript-eslint/no-unused-vars

return {
  byId,
  allIds: [
    ...state.allIds.slice(0, indexToRemove),
    ...state.allIds.slice(indexToRemove + 1)
  ],
};
}

export function removeEntities<T extends BaseEntity>(state: EntityState<T>, ids: string[]): EntityState<T> {
  return ids.reduce(removeEntity, state);
}
